/**
 * "Now", as one substitutable thing.
 *
 * The home page's whole visual language is a function of today's date, so a test that cannot move
 * the clock cannot assert the colour of a row. Every date decision reads this, never `new Date()`.
 *
 * 034: an `InjectionToken` with a factory becomes a module value with a setter. The property that
 * mattered — a test can replace it — is kept; the injector that provided it is not.
 */
let current: () => Date = () => new Date();

export const clock = (): Date => current();

/** Test seam. Production code never calls it. */
export function setClock(next: () => Date): void {
  current = next;
}
